import React from 'react';
import { useNavigate } from 'react-router-dom';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import HistoryIcon from '@mui/icons-material/History';
import URL from '@/common/routes/Url';

const HistoryManagement: React.FC = () => {
  const navigate = useNavigate();

  const toHistory = () => {
    navigate(URL.historyExport);
  };

  return (
    <List dense disablePadding>
      <ListItemButton /*sx={{ pl: 4 }}*/>
        <ListItemIcon>
          <HistoryIcon />
        </ListItemIcon>
        <ListItemText primary="操作履歴" onClick={toHistory} />
      </ListItemButton>
    </List>
  );
};
export default HistoryManagement;
